import { render, staticRenderFns } from "./SizeColorDialog.vue?vue&type=template&id=a5a3d708&scoped=true"
import script from "./SizeColorDialog.vue?vue&type=script&lang=js"
export * from "./SizeColorDialog.vue?vue&type=script&lang=js"
import style0 from "./SizeColorDialog.vue?vue&type=style&index=0&id=a5a3d708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a3d708",
  null
  
)

export default component.exports